<template>
	<div>
		<div class="pd_time_pc" v-if="!isPhone">
			<div class="flex3">
				<img src="@/images/shizhong.png">
				<span class="ml_5">{{ atime.slice(0,10) }}</span>
			</div>
			<div class="flex3 ptm_d2">
				<div>字号</div>
				<div class="add_cut" :class="actzh==1?'zh_act':''" @click="setFont(1)"><span>A</span><span class="ac_fh">-</span>
				</div>
				<div class="zh_deft" :class="actzh==2?'zh_act':''" @click="setFont(2)">A</div>
				<div class="add_cut" :class="actzh==3?'zh_act':''" @click="setFont(3)"><span>A</span><span class="ac_fh">+</span>
				</div>
			</div>
			<div class="ptm_d3">
				<img @click="handlePrint" src="@/images/dy.png">
			</div>
		</div>
		<div class="pd_time_phone" v-if="isPhone">
			<div class="flex3">
				<img src="@/images/shizhong.png">
				<span class="ml_5">{{ atime }}</span>
			</div>
			<div class="flex3 ptm_d2">
				<div>字号</div>
				<div class="add_cut" :class="actzh==1?'zh_act':''" @click="setFont(1)"><span>A</span><span class="ac_fh">-</span>
				</div>
				<div class="zh_deft" :class="actzh==2?'zh_act':''" @click="setFont(2)">A</div>
				<div class="add_cut" :class="actzh==3?'zh_act':''" @click="setFont(3)"><span>A</span><span class="ac_fh">+</span>
				</div>
			</div>
			<div class="ptm_d3">
				<img @click="handlePrint" src="@/images/dy.png">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		atime: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			actzh: 2,
			ftsize: 16,
			ftsize2: 0.39,
			isPhone: this.$isMobile,
		}
	},
	created() {

	},
	methods: {
		handlePrint() {
			window.print();
		},
		setFont(a) {
			this.actzh = a;
			if (this.isPhone) {
				if (a == 1) {
					this.ftsize2 = this.ftsize2 - 0.05;
				}
				if (a == 2) {
					this.ftsize2 = 0.39;
				}
				if (a == 3) {
					this.ftsize2 = this.ftsize2 + 0.05;
				}
				this.$emit('font-size', this.ftsize2)
			} else {
				if (a == 1) {
					this.ftsize = this.ftsize - 2;
				}
				if (a == 2) {
					this.ftsize = 16;
				}
				if (a == 3) {
					this.ftsize = this.ftsize + 2;
				}
				this.$emit('font-size', this.ftsize)
			}

		}
	}
}
</script>

<style lang="scss">
.zh_act {
	color: #b50104 !important;
}
.pd_time_pc {
	line-height: 32px;
	font-size: 16px;
	margin: 20px 0;
	color: #7c7c7c;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #eae7e7;
	.ptm_d2 {
		margin: 0 60px;
		.add_cut {
			padding: 2px 7px;
			cursor: pointer;
			.ac_fh {
				position: relative;
				top: -4px;
				font-size: 12px;
			}
		}
		.zh_deft {
			padding: 2px 7px;
			cursor: pointer;
			position: relative;
			top: -0.5px;
		}
	}
	.ptm_d3 {
		cursor: pointer;
	}
}
.pd_time_phone {
	line-height: 0.78rem;
	font-size: 0.35rem;
	margin: 0.5rem 0;
	color: #7c7c7c;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: #eae7e7;
    padding: 0 0.2rem;
	.ptm_d2 {
		.add_cut {
			padding: 2px 7px;
			cursor: pointer;
			.ac_fh {
				position: relative;
				top: -4px;
				font-size: 0.29rem;
			}
		}
		.zh_deft {
			padding: 2px 7px;
			cursor: pointer;
		}
	}
	.ptm_d3 {
		cursor: pointer;
	}
}
</style>